const spacing11 = "60px";
const spacing10 = "48px";
const spacing9 = "40px";
const spacing8 = "32px";
const spacing7 = "24px";
const spacing6 = "20px";
const spacing5 = "16px";
const spacing4 = "12px";
const spacing3 = "8px";
const spacing2 = "4px";
const spacing1 = "2px";
const spacing0 = "0px";
const spacings = {
  spacing11,
  spacing10,
  spacing9,
  spacing8,
  spacing7,
  spacing6,
  spacing5,
  spacing4,
  spacing3,
  spacing2,
  spacing1,
  spacing0
};
export {
  spacings as default,
  spacing0,
  spacing1,
  spacing10,
  spacing11,
  spacing2,
  spacing3,
  spacing4,
  spacing5,
  spacing6,
  spacing7,
  spacing8,
  spacing9
};
//# sourceMappingURL=index.es15.js.map
